export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["AlertsToK2"] = "alertsToK2";
    FeatureFlag["AlertOnErrors"] = "alertOnErrors";
    FeatureFlag["AnalysisContextWithCoreWebVitals"] = "analysisContextWithCoreWebVitals";
    FeatureFlag["AnalysisContextWithCoreWebVitalsAnyPageFovV2"] = "analysisContextWithCoreWebVitalsAnyPageFovV2";
    FeatureFlag["AnalysisContextWithSamePageviewCoreWebVitals"] = "analysisContextWithSamePageviewCoreWebVitals";
    FeatureFlag["AnalysisContextWithAccessibility"] = "analysisContextWithAccessibility";
    FeatureFlag["ApiErrorsExtraData"] = "apiErrorsExtraData";
    FeatureFlag["ApiErrorsInFrustrationScore"] = "apiErrorsInFrustrationScore";
    FeatureFlag["ApplySamplingToAll"] = "applySamplingToAll";
    FeatureFlag["AuditLogMigration"] = "audit-log-migration";
    FeatureFlag["BoostReplayQuotas"] = "boostReplayQuotas";
    FeatureFlag["BrowserTelemetry"] = "browserTelemetry";
    FeatureFlag["CustomErrors"] = "customErrors";
    FeatureFlag["dVarSessionLevel"] = "dVarSessionLevel";
    FeatureFlag["DataLensSegmentation"] = "dataLensSegmentation";
    FeatureFlag["DailyAlerts"] = "dailyAlerts";
    FeatureFlag["EnrichmentSegmentation"] = "enrichmentSegmentation";
    FeatureFlag["ERM"] = "ERM";
    FeatureFlag["ERM3"] = "ERM3";
    FeatureFlag["EmerchProductExposure"] = "emerchProductExposure";
    FeatureFlag["EmerchPagePerformance"] = "emerchPagePerformance";
    FeatureFlag["ErrorsJiraIntegration"] = "errorsJiraIntegration";
    FeatureFlag["ErrorsTabsVisibility"] = "errorsTabsVisibility";
    FeatureFlag["ErrorsSidePanel"] = "errorsSidePanel";
    FeatureFlag["ErrorsNewGrouping"] = "errorsNewGrouping";
    FeatureFlag["FovExpanderRefactor"] = "fovExpanderRefactor";
    FeatureFlag["GlobalParamsInConsole"] = "globalParamsInConsole";
    FeatureFlag["InsightsReduceFalsePositive"] = "insightsReduceFalsePositive";
    FeatureFlag["InsightsReduceFalsePositiveEnabled"] = "insightsReduceFalsePositiveEnabled";
    FeatureFlag["IntegrationsCatalog"] = "integrationsCatalog";
    FeatureFlag["ImpactIntoPlayer"] = "impactIntoPlayer";
    FeatureFlag["ImpactK2"] = "ImpactK2";
    FeatureFlag["ImpactForSDK"] = "impactForSDK";
    FeatureFlag["JourneyAnalysisAfterAPageBreakdown"] = "journeyAnalysisAfterAPageBreakdown";
    FeatureFlag["JourneyAnalysisShare"] = "journeyAnalysisShare";
    FeatureFlag["JourneyAnalysisCopyToClipboard"] = "journeyAnalysisCopyToClipboard";
    FeatureFlag["JourneyAnalysisFunnel"] = "journeyAnalysisFunnel";
    FeatureFlag["JourneyAnalysisHeaderK2"] = "journeyAnalysisHeaderK2";
    FeatureFlag["MappingsK2"] = "MappingsK2";
    FeatureFlag["MappingsLinkedObjectsBulkDeletion"] = "MappingsLinkedObjectsBulkDeletion";
    FeatureFlag["MappingRightManagement"] = "mappingRightManagement";
    FeatureFlag["MetadataIntoPlayer"] = "metadataIntoPlayer";
    FeatureFlag["MetricsApiFullRetention"] = "MetricsApiFullRetention";
    FeatureFlag["MetricsApiKrapiMigration"] = "MetricsApiKrapiMigration";
    FeatureFlag["MobileErrorAnalysis"] = "mobileErrorAnalysis";
    FeatureFlag["MobileSrMissingFonts"] = "mobileSrMissingFonts";
    FeatureFlag["MultiClicks"] = "errorWithMultipleClicks";
    FeatureFlag["NewBrandLogo"] = "newBrandLogo";
    FeatureFlag["NewCSLive"] = "newCSLive";
    FeatureFlag["NewProjectProductFlag"] = "newProjectProductFlag";
    FeatureFlag["NextCloudMultiEnv"] = "nextCloudMultiEnv";
    FeatureFlag["ORMGuard"] = "ORMGuard";
    FeatureFlag["PageComparatorWithCoreWebVitals"] = "pageComparatorWithCoreWebVitals";
    FeatureFlag["RealtimeAlerts"] = "realtimeAlerts";
    FeatureFlag["RztIndicatorsInFrustrationScore"] = "rztIndicatorsInFrustrationScore";
    FeatureFlag["SegmentsToK2"] = "segmentsToK2";
    FeatureFlag["SegmentsV2PIP"] = "segmentsV2PIP";
    FeatureFlag["SessionLevelClickRate"] = "sessionLevelClickRate";
    FeatureFlag["SessionLevelTapRate"] = "sessionLevelTapRate";
    FeatureFlag["SessionReplayQuotas"] = "sessionReplayQuotas";
    FeatureFlag["SessionReplaySearchByIP"] = "sessionReplaySearchByIP";
    FeatureFlag["SideListUrlPlayer"] = "sideListUrlPlayer";
    FeatureFlag["ShowTouchEventsInSessionPlayer"] = "showTouchEventsInSessionPlayer";
    FeatureFlag["StorageLocationOnAzureForCsApps"] = "storageLocationOnAzureForCsApps";
    FeatureFlag["StopMechanisms"] = "stopMechanisms";
    FeatureFlag["SwipeRateWebMetric"] = "swipeRateWebMetric";
    FeatureFlag["TagManagerImplementationsTab"] = "tagManagerImplementationsTab";
    FeatureFlag["TeamAssignmentRule"] = "teamAssignmentRule";
    FeatureFlag["UserCentric"] = "userCentric";
    FeatureFlag["UseNewPlayerK2"] = "useNewPlayerK2";
    FeatureFlag["UseStreamModePlayerEvents"] = "useStreamModePlayerEvents";
    FeatureFlag["UseShellUXAnalytics"] = "useShellUXAnalytics";
    FeatureFlag["WithSpeedAnalysisComparisonForms"] = "withSpeedAnalysisComparisonForms";
    FeatureFlag["WithSpeedAnalysisLCPHelper"] = "withSpeedAnalysisLCPHelper";
    FeatureFlag["WithSpeedAnalysisJumpToPointLCPHelper"] = "withSpeedAnalysisJumpToPointLCPHelper";
    FeatureFlag["WithWorkspaceMetricUniversalSelector"] = "withWorkspaceMetricUniversalSelector";
    FeatureFlag["WithSpeedAnalysisScenarioStepReport"] = "withSpeedAnalysisScenarioStepReport";
    FeatureFlag["WithSpeedAnalysisScenarioManualExecution"] = "withSpeedAnalysisScenarioManualExecution";
    FeatureFlag["WithSpeedAnalysisVideoPlayerNewMetrics"] = "withSpeedAnalysisVideoPlayerNewMetrics";
    FeatureFlag["WithSpeedAnalysisStandaloneReportWaterfall"] = "withSpeedAnalysisStandaloneReportWaterfall";
    FeatureFlag["WithSpeedAnalysisComparisonReportWaterfall"] = "withSpeedAnalysisComparisonReportWaterfall";
    FeatureFlag["WithSpeedAnalysisScenarioStepReportWaterfall"] = "withSpeedAnalysisScenarioStepReportWaterfall";
    FeatureFlag["WorkspaceFunnel"] = "workspaceFunnel";
    FeatureFlag["WorkspaceNRT"] = "workspaceNRT";
    FeatureFlag["WorkspaceSegmentStacking"] = "workspaceSegmentStacking";
    FeatureFlag["WorkspaceTemplatesV2"] = "workspaceTemplatesV2";
    FeatureFlag["WorkspaceWithCoreWebVitals"] = "workspaceWithCoreWebVitals";
    FeatureFlag["WorkspaceWithCoreWebVitalsOperators"] = "workspaceWithCoreWebVitalsOperators";
    FeatureFlag["WorkspaceWithMetricSelector"] = "workspaceWithMetricSelector";
    FeatureFlag["WorkspaceShareModal"] = "workspaceShareModal";
    FeatureFlag["WorkspaceUserCentricity"] = "workspaceUserCentricity";
    FeatureFlag["ZoningAutoZone"] = "zoningAutoZone";
    FeatureFlag["ZoningExportWithPlaywrightPOC"] = "zoningExportWithPlaywrightPOC";
    FeatureFlag["ZoningFASegments"] = "zoningFAsegments";
    FeatureFlag["ZoningRetroCompatibility"] = "zoningRetroCompatibility";
    FeatureFlag["ZoningScrollReach"] = "zoningScrollReach";
    FeatureFlag["ZoningSnapshotExportV2"] = "zoningSnapshotExportV2";
    FeatureFlag["ZoningNewZoneLayout"] = "zoningNewZoneLayout";
    FeatureFlag["ZoningBackendMidzoneheight"] = "zoningBackendMidzoneheight";
    FeatureFlag["ZoningChangeDetectionPOC"] = "zoningChangeDetectionPOC";
    FeatureFlag["ZoningCreateZonesByArea"] = "zoningCreateZonesByArea";
    FeatureFlag["zoningZonlayoutHistV2"] = "zoningZonlayoutHistV2";
    FeatureFlag["ProjectDynamicSnippetPublishRefacto"] = "projectDynamicSnippetPublishRefacto";
})(FeatureFlag || (FeatureFlag = {}));
//# sourceMappingURL=feature-flag.js.map